// Driving-school classroom layout, 1280×720 world coords (bg_driving_school).
// Phaser-free so it loads under `node --test`.
//
// Traced against the real art (2026-08-28) by scanning the wainscot/floor colour
// boundary column-by-column, not by eyeballing: the room is a shallow one-point box
// with an angled left wall carrying the exit door, benches front-left, the
// instructor's desk right-of-centre and a potted plant in the right corner.
// Then checked in the running game by drawing FLOOR/OBSTACLES/EXIT_DOOR over the
// background (the plant's footprint was the one rect that needed moving down).

// Floor polyline: [x, y] FEET positions (WalkController.getFloorYAt interpolates and
// keeps the sprite centre h/2 above this line). The left wall recedes steeply
// (y 540 → 446 between x 0 and 200), the back wall bottoms out around y 422 mid-room
// and drifts back down to ~460 behind the desk.
export const FLOOR = [
  [0, 540], [60, 500], [105, 478], [150, 458], [200, 446],
  [500, 432], [640, 422], [900, 440], [1100, 458], [1279, 462],
];

// Obstacle rectangles the FEET may not enter ({x, y, w, h}, x/y = top-left).
// Collision is tested on a single feet POINT, so the 30 px lane between the left wall
// and the first bench (x 90…120) is enough to reach the exit door in the back corner.
export const OBSTACLES = [
  { x: 720, y: 400, w: 375, h: 105, what: 'biurko instruktorki (desk)' },
  { x: 120, y: 570, w: 340, h: 50,  what: 'ławka 1 (front bench)' },
  { x: 195, y: 485, w: 300, h: 45,  what: 'ławka 2 (middle bench)' },
  { x: 248, y: 440, w: 300, h: 40,  what: 'ławka 3 (back bench)' },
  { x: 1170, y: 470, w: 110, h: 75, what: 'roślina w rogu (plant, right corner)' },
];

// Exit door: the wooden door on the left wall. Its threshold in the art slopes from
// (9, 476) to (152, 450); the trigger is the reachable strip of floor in front of it.
export const EXIT_DOOR = { x: 85, y: 452, w: 100, h: 65 };

// Default entry position (sprite centre). Front-left of the room, clear of the benches
// and well away from EXIT_DOOR so walking in doesn't bounce you straight back out.
export const SPAWN = { x: 260, y: 585 };

// How close (sprite centres) you must be to talk to the instructor.
export const NPC_NEAR = 160;

export function rectContains(r, x, y) {
  return x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h;
}

export function feetInAnyRect(rects, x, y) {
  for (const r of rects) if (rectContains(r, x, y)) return true;
  return false;
}
